<template>
  <v-row v-if="!isResellerSubAccount">
    <v-col cols="12">
      <gg-card>
        <gg-card-text>
          <div class="body-1 mb-5">
            <v-icon size="24" color="primary" class="pb-1">mdi-account-settings</v-icon>
            <span class="ml-2">{{ serviceInfoTitle }}</span>
          </div>
          <v-list>
            <v-list-item>
              <v-list-item-content v-if="!isResellerSubAccount">
                <v-list-item-subtitle><strong>Plan Type</strong></v-list-item-subtitle>
                <v-list-item-title>
                  {{ hosting.name }}
                  <v-icon size="medium">
                    {{ iconFlag(hosting.flag) }}
                  </v-icon>
                  <a v-if="hosting.changeplan"
                     href="#"
                     class="d-block"
                     @click.prevent="handleChangePlan">
                    Change Plan
                  </a>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-subtitle><strong>Status</strong></v-list-item-subtitle>
                <v-list-item-title>
                  <v-icon small class="pb-1" :color="statusColor(hosting.status)">mdi-circle</v-icon> {{ hosting.status }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content v-if="!isResellerSubAccount">
                <v-list-item-subtitle><strong>Billing Cycle</strong></v-list-item-subtitle>
                <v-list-item-title>{{ hosting.renewalterm }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-subtitle><strong>Renewal Date</strong></v-list-item-subtitle>
                <v-list-item-title>
                  {{ formatRenewalDate(parseRenewalDate(hosting.renewaldate)) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="my-0"></v-divider>

            <v-list-item>

              <v-list-item-content>
                <v-list-item-subtitle><strong>Password Management</strong></v-list-item-subtitle>
                <v-list-item-title>
                  <router-link :to="changePasswordRoute">
                    Change Password
                  </router-link>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-content v-if="!isResellerSubAccount">
                <v-list-item-subtitle><strong>Sharing Options</strong></v-list-item-subtitle>
                <v-list-item-title>
                  <shared-service-tag v-if="hosting.sharedaccount || hosting.sharedaccess"
                                      :service="hosting"></shared-service-tag>
                  <router-link v-else :to="{ name: 'profile_access' }">
                    Enable Sharing
                  </router-link>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-content v-if="currentHosting.cancellation_type === 'addon'">
                <v-list-item-subtitle>
                  <strong>Addon Cancellation</strong>
                </v-list-item-subtitle>
                <v-list-item-title>
                  <router-link
                    :to="`/cancellations/${currentHosting.cancellation_id}`"
                    aria-label="View Request">
                    View Request
                  </router-link>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-content v-else-if="!isResellerSubAccount">
                <v-list-item-subtitle>
                  <div v-if="currentHosting.autorenew">
                    <div style="font-weight: bold;">
                      Auto Renew: Enabled
                    </div>
                  </div>
                  <div v-else>
                    <div style="font-weight: bold;">
                      Auto Renew: Disabled
                    </div>
                  </div>
                </v-list-item-subtitle>
                <v-list-item-title>
                  <router-link
                    v-if="currentHosting.autorenew"
                    :to="{ name: 'cancel', params: { service_id: hosting.id }, query: { type: cancellationTypes.HOSTING }}">
                    {{ hosting.status === 'Suspended' ? 'Submit Cancellation' : 'Disable Auto-Renew' }}
                  </router-link>
                  <a v-else href="#" @click="canAutorenewProceed">
                    Enable Auto-Renew
                  </a>
                </v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list>
          <auto-renew-modal ref="autoRenewModal"></auto-renew-modal>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  statusColor,
  parseRenewalDate,
  iconFlag,
  formatRenewalDate
} from '@/helpers/helpers'
import SharedServiceTag from 'Components/Common/SharedServiceTag'
import AutoRenewModal from 'Components/Services/Hosting/Shared/Overview/AutoRenewModal.vue'
import { cancellationTypes } from '@/consts/cancellations'

export default {
  name: 'ServiceInfo',

  components: {
    AutoRenewModal,
    SharedServiceTag,
  },

  data () {
    return {
      autorenewModalOpen: false,
      cancellationTypes,
      autorenewModalConfirmOpen: false,
      autorenewLoading: false,
      serviceInfoTitle: '',
    }
  },
  computed: {
    ...mapGetters(['hosting', 'services']),
    currentHosting () {
      return this.services.find(service => service.id == this.hosting.id)
    },
    isResellerSubAccount () {
      return this.$route.query.user && this.hosting.groupname === 'Reseller Hosting'
    },
    changePasswordRoute () {
      if (this.hosting.groupname === 'Shared Hosting' || this.isResellerSubAccount) {
        return { name: 'hosting_cpanel_password', query: { user: this.$route.query.user } }
      } else if (this.hosting.groupname === 'Reseller Hosting') {
        return { name: 'hosting_whm_password' }
      } else if (this.hosting.groupname === 'Virtual Private Server') {
        return { name: 'hosting_vserver_password' }
      }
      return { name: 'hosting_cpanel_password' }
    }
  },
  methods: {
    statusColor,
    parseRenewalDate,
    iconFlag,
    formatRenewalDate,
    handleChangePlan () {
      if (this.hosting.updowngrade_request === 0) {
        this.$router.push({
          name: 'hosting_create_request',
          query: {
            user: this.$route.query.user
          },
        })
      } else {
        this.$router.push({
          name: 'hosting_view_request',
          params: {
            id: this.hosting.updowngrade_request
          },
          query: {
            user: this.$route.query.user
          },
        })
      }
    },
    canAutorenewProceed () {
      this.$refs.autoRenewModal.canAutorenewProceed()
    },
    setServiceInfoTitle () {
      this.serviceInfoTitle = this.$route.name === 'hosting_whm_info' ? 'Reseller Account Details' : 'Plan Details'
    },
  },
  created () {
    this.setServiceInfoTitle()
  }
}
</script>
